module.exports = __webpack_public_path__ + "img/hotPoint.0458d755.gif";